module.exports = new __parcel__URL__("rat.0710dbcc.webp").toString();